import type { GliderPayload } from './types'

export function partitionGliders(gliders: GliderPayload[]) {
  return {
    active: gliders.filter(glider => !glider.retired),
    retired: gliders.filter(glider => glider.retired),
  }
}
